<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'ANNOUNCEMENTS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'ANNOUNCEMENTS.ADMIN_SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-primary" *appAccess="'announcements:add'" (click)="onAdd()">
        <mat-icon>add</mat-icon>
        {{ 'ANNOUNCEMENTS.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="card">
    <div class="table-scroll">
      <div class="empty-state" *ngIf="loading">{{ 'ANNOUNCEMENTS.LOADING' | translate }}</div>

      <table class="data-table" *ngIf="!loading && items.length; else emptyAnnouncements">
        <thead>
          <tr>
            <th>{{ 'ANNOUNCEMENTS.COLUMN' | translate }}</th>
            <th style="width: 100px;">{{ 'ANNOUNCEMENTS.ACTIVE' | translate }}</th>
            <th style="width: 160px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items" class="clickable" (click)="openRow(item)">
            <td class="announcement-text">{{ item.text }}</td>
            <td>
              <span class="status-badge" [class.active]="item.active">
                {{ (item.active ? 'ANNOUNCEMENTS.YES' : 'ANNOUNCEMENTS.NO') | translate }}
              </span>
            </td>
            <td class="row-actions" (click)="$event.stopPropagation()">
              <ng-container *appAccess="'announcements:edit'">
                <button type="button" class="btn btn-secondary btn-sm" (click)="onEdit(item)">
                  {{ 'COMMON.EDIT' | translate }}
                </button>
              </ng-container>
              <ng-container *appAccess="'announcements:delete'">
                <button type="button" class="btn btn-danger btn-sm" (click)="onDelete(item)">
                  {{ 'COMMON.DELETE' | translate }}
                </button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #emptyAnnouncements>
        <div class="empty-state" *ngIf="!loading">{{ 'ANNOUNCEMENTS.EMPTY' | translate }}</div>
      </ng-template>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showDeleteModal">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header"><h3>{{ 'COMMON.CONFIRM_DELETE' | translate }}</h3></div>
    <div class="modal-body"><p>{{ deleteModalBody | translate }}</p></div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onDeleteConfirm(false)">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-danger" (click)="onDeleteConfirm(true)">
        {{ 'COMMON.DELETE' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ mode === 'view' ? ('ANNOUNCEMENTS.COLUMN' | translate) : ((mode === 'edit' ? 'ANNOUNCEMENTS.EDIT_TITLE' : 'ANNOUNCEMENTS.ADD_TITLE') | translate) }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-field">
          <label for="announcementText">{{ 'ANNOUNCEMENTS.TEXT' | translate }}</label>
          <textarea
            id="announcementText"
            rows="4"
            formControlName="text"
            [placeholder]="'ANNOUNCEMENTS.TEXT_PLACEHOLDER' | translate"
          ></textarea>
          <span class="error" *ngIf="form.get('text')?.touched && form.get('text')?.hasError('required')">
            {{ 'ANNOUNCEMENTS.TEXT_REQUIRED' | translate }}
          </span>
        </div>
        <label class="checkbox-field">
          <input type="checkbox" formControlName="active" />
          <span>{{ 'ANNOUNCEMENTS.ACTIVE_HINT' | translate }}</span>
        </label>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">
        {{ (mode === 'view' ? 'COMMON.CLOSE' : 'COMMON.CANCEL') | translate }}
      </button>
      <button type="button" class="btn btn-primary" *ngIf="mode !== 'view'" (click)="submit()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
